import React from 'react';

import utils from '@utils/util';
import { appMethod as app } from '@utils/app';
import { List, Switch } from 'antd-mobile';
import OfficialPage from '../../official-page/OfficialPage';
import './SignIn.less';

/**
 * type: 'sign-in'
 * 组件：每日签到组件
 */
export default class SignIn extends OfficialPage {
  state = {
    eles: []
  }
  constructor(props) {
    super(props);
    const compindex = props.index;
    const pageInstance = app.getAppCurrentPage();
    this.init(0, this);
  }
  
  init = (compindex, pageInstance) => {
    app.getStorage({
      'key': 'activityData',
      success: (res) => {
        if (res.data) {
          this.signInExtraRewards(compindex, pageInstance, Number(res && res.data && res.data.id))
        }
      }
    })
    this.signInGetActivity(compindex, pageInstance);
  }

  // 获取活动详情
  signInGetActivity = (compindex, pageInstance) => {
    let newData = {};
    app.sendRequest({
      url: '/index.php?r=appSignActivity/GetEffectActivity',
      data: {},
      success: (res) => {
        app.setStorage({
          key: 'activityData',
          data: res.data
        });
        let start_time = new Date(res.data.start_time * 1000).toLocaleDateString();
        let end_time = new Date(res.data.end_time * 1000).toLocaleDateString();
        let activityData = res.data;
        let style_settings = res.data.style_settings;
        let advance = res.data.style_settings.advance || '';
        const cur_date = utils.formatTimeYMD('', 'MM.DD'); // 获取当前时间
        newData['eles[' + compindex + '].start_time'] = start_time;
        newData['eles[' + compindex + '].end_time'] = end_time;
        newData['eles[' + compindex + '].cur_date'] = cur_date;
        newData['eles[' + compindex + '].sign_type'] = res.data.sign_type;
        newData['eles[' + compindex + '].continuous_notice'] = res.data.continuous_notice;
        newData['eles[' + compindex + '].activity_id'] = Number(res.data.id);
        newData['eles[' + compindex + '].activityData'] = activityData;
        newData['eles[' + compindex + '].style_settings'] = style_settings;
        newData['eles[' + compindex + '].default_style'] = style_settings.default_style;
        newData['eles[' + compindex + '].advance'] = advance;
        newData['eles[' + compindex + '].isLoading'] = false;

        newData['eles[' + compindex + '].showDateArr'] = [];
        newData['eles[' + compindex + '].sendFormIdTimes'] = 0;
        newData['eles[' + compindex + '].showGetRetroModal'] = false;
        newData['eles[' + compindex + '].showSignMask'] = false;
        newData['eles[' + compindex + '].showSignSus'] = false;
        newData['eles[' + compindex + '].showExchangeModal'] = false;
        newData['eles[' + compindex + '].timer'] = null;
        
        pageInstance.setData(newData);
        this.signInGetContinuousDay(compindex, pageInstance); // 连续签到日期
        this.signInExtraRewards(compindex, pageInstance); // 查看可领额外奖励
        this.signInGetIntegralInfo(compindex, pageInstance); // 刷新积分
        if (res.data.continuous_notice === '1') {
          this.signInGetUserNotice(compindex, pageInstance); // 查询用户连续签到提醒设置
        }
      },
      successStatusAbnormal: function () {
        newData['eles[' + compindex + '].nodata'] = true;
        pageInstance.setData(newData);
        return false;
      }
    })
  }

  // 获取已连续签到的天数
  signInGetContinuousDay = (compindex, pageInstance) => {
    let newData = {};
    let activity_id = pageInstance.data.eles[compindex].activity_id;
    app.sendRequest({
      url: '/index.php?r=appSignActivity/GetContinuousDay',
      data: {
        activity_id: activity_id,
      },
      success: (res) => {
        newData['eles[' + compindex + '].continuous_sign'] = res.data.continuous_sign;
        pageInstance.setData(newData);
        this.signInDateIsSign(compindex, pageInstance); // 判断今日是否签到
      }
    })
  }

  // 可领取的奖励列表
  signInExtraRewards = (compindex, pageInstance, id) => {
    let newData = {};
    let activity_id = id || pageInstance.data.eles[compindex].activity_id;
    app.sendRequest({
      url: '/index.php?r=appSignActivity/GetExtraRewards',
      data: {
        activity_id: activity_id,
      },
      success: function (res) {
        newData['eles[' + compindex + '].continuous_array'] = res.data.continuous;
        newData['eles[' + compindex + '].accumulate_array'] = res.data.accumulate;
        pageInstance.setData(newData);
      },
      successStatusAbnormal: function () {
        return false;
      }
    })
  }

  // 获取用户连续签到提醒开关
  signInGetUserNotice = (compindex, pageInstance) => {
    let activity_id = pageInstance.data.eles[compindex].activity_id;
    let newData = {};
    app.sendRequest({
      url: '/index.php?r=appSignActivity/GetUserNoticeSwitch',
      data: {
        activity_id: activity_id
      },
      success: function (res) {
        newData['eles[' + compindex + '].continuous_notice_user'] = res.data == 0 ? false : true;
        pageInstance.setData(newData)
      },
      successStatusAbnormal: function () {
        return false;
      }
    })
  }

  // 判断当天有无签到
  signInDateIsSign = (compindex, pageInstance) => {
    let activity_id = pageInstance.data.eles[compindex].activity_id;
    app.sendRequest({
      url: '/index.php?r=appSignActivity/DateIsSign',
      data: {
        activity_id: activity_id,
        sign_date: new Date().toDateString()
      },
      success: (res) => {
        let newData = {};
        if (res.data.is_sign) {
          newData['eles[' + compindex + '].hasSign'] = true;
          pageInstance.setData(newData);
        } else if (pageInstance.data.eles[compindex].sign_type == 2) { // 开启极速签到 
          this.signIn(compindex, pageInstance, '');
        }
        this.getTimeLength(compindex, pageInstance);
      }
    })
  }

  // 签到
  signIn = (compindex, pageInstance, form_id) => {
    let width = 0;
    let newData = {};
    let sign_type = pageInstance.data.eles[compindex].sign_type;
    let cur_date = pageInstance.data.eles[compindex].cur_date;
    let activity_id = pageInstance.data.eles[compindex].activity_id;
    let hasSign = pageInstance.data.eles[compindex].hasSign;
    let showDateArr = [...pageInstance.data.eles[compindex].showDateArr];
    let isLoading = pageInstance.data.eles[compindex].isLoading; // false
    if (isLoading) return;
    newData['eles[' + compindex + '].isLoading'] = true;
    pageInstance.setData(newData);
    app.sendRequest({
      url: '/index.php?r=appSignActivity/SignIn',
      method: 'post',
      data: {
        activity_id: activity_id,
        homepageRouter: 'pages/' + app.globalData.homepageRouter + '/' + app.globalData.homepageRouter,
        form_id: form_id
      },
      success: (res) => {
        for (let i = 0; i < showDateArr.length; i++) {
          if (showDateArr[i].date === cur_date) {
            showDateArr[i].isSign = true;
            // 展示数组的总宽度是 630 去掉前端和后端 应为540 
            if (!hasSign && i === 0) {
              width = 20;
            } else {
              width = i / (showDateArr.length - 1) * 540 + 60;
            }
            newData['eles[' + compindex + '].signInProgressWidth'] = width;
          }
        }
        newData['eles[' + compindex + '].hasSign'] = true;
        newData['eles[' + compindex + '].showDateArr'] = showDateArr;
        newData['eles[' + compindex + '].showSignSus'] = true;
        newData['eles[' + compindex + '].showSignMask'] = true;
        newData['eles[' + compindex + '].successTips'] = sign_type == 2 ? '极速签到成功' : '签到成功';
        pageInstance.setData(newData, () => {
          this.signInRewardCheck(compindex, pageInstance); // 获取每日额外奖励
          this.signInExtraRewards(compindex, pageInstance); //  查看可额外领取的奖励
          this.signInGetSignedDates(compindex, pageInstance); // 查询所有已签到的日期
          this.signInGetContinuousDay(compindex, pageInstance); // 获取已连续签到的天数
          this.signInCloseSignModal(compindex, pageInstance); // 关闭弹窗
          this.signInGetIntegralInfo(compindex, pageInstance); // 刷新积分
        });
      },
      complete: (res) => {
      }
    })
  }

  // 只获取时间轴
  getTimeLength = (compindex, pageInstance) => {
    // 拿到今天的日期，连续签到的天数,
    let st = new Date();
    let et = new Date();
    let day1 = pageInstance.data.eles[compindex].start_time;
    let day2 = pageInstance.data.eles[compindex].end_time;
    let continuous_sign = pageInstance.data.eles[compindex].continuous_sign;
    let hasSign = pageInstance.data.eles[compindex].hasSign;
    // 若连续签到为7天的倍数  开始时间则为今天
    if (continuous_sign % 7 == 0 && !hasSign) {} else {
      // 否则开始时间则往前算连续签到的天数 取余
      continuous_sign = hasSign ? continuous_sign - 1 : continuous_sign;
      st = new Date(st.getTime() - continuous_sign % 7 * 24 * 60 * 60 * 1000);
    }
    // 时间轴长度
    let date_length = Math.floor((new Date(day2).getTime() - st.getTime()) / (24 * 60 * 60 * 1000)) + 1;
    if (date_length >= 7) {
      et = utils.formatTimeYMD(new Date(st.getTime() + 6 * (24 * 60 * 60 * 1000)), 'YYYY/MM/DD')
    } else {
      et = utils.formatTimeYMD(new Date(st.getTime() + date_length * (24 * 60 * 60 * 1000)), 'YYYY/MM/DD')
    }
    st = utils.formatTimeYMD(st, 'YYYY/MM/DD');
    let dateArr = this.signInGetDays(st, et);
    let newData = {};
    newData['eles[' + compindex + '].dateArr'] = dateArr;
    pageInstance.setData(newData);
    this.signInRewardCheck(compindex, pageInstance); // 查询每日奖励
  }

  // 获取日期数组
  signInGetDays = (day1, day2) => {
    let st = new Date(day1);
    let et = new Date(day2);
    let arr = [];
    // 获取开始的日期 (年，月，日)
    let yyyy = st.getFullYear(),
      mm = st.getMonth(),
      dd = st.getDate();
    // 循环
    while (st.getTime() <= et.getTime()) {
      arr.push(utils.formatNumber(st.getMonth() + 1) + '.' + utils.formatNumber(st.getDate()));
      // 使用dd++进行天数的自增
      st = new Date(yyyy, mm, ++dd);
    };
    let brr = arr.map((item, index) => {
      return {
        isSign: false,
        date: item
      }
    })
    return brr;
  }

  // 查看每日可领取的奖励
  signInRewardCheck = (compindex, pageInstance) => {
    let activity_id = pageInstance.data.eles[compindex].activity_id;
    let dateArr = pageInstance.data.eles[compindex].dateArr;
    let newData = {};
    app.sendRequest({
      url: '/index.php?r=appSignActivity/DaysRewards',
      data: {
        'activity_id': activity_id,
        'days': dateArr.length,
      },
      success: (res) => {
        for (let i = 0; i < dateArr.length; i++) {
          for (let j = 0; j < res.data.length; j++) {
            // 获取当日日期
            if (utils.formatTimeYMD(res.data[j].timestamps, 'MM.DD') == dateArr[i].date) {
              dateArr[i].accumulatedReward = res.data[j].accumulatedReward;
              dateArr[i].continuousReward = res.data[j].continuousReward;
              dateArr[i].integral = res.data[j].integral;
            }
          }
        }
        newData['eles[' + compindex + '].giftTips_con'] = res.continuous_str;
        newData['eles[' + compindex + '].giftTips_acc'] = res.accumulated_str;
        newData['eles[' + compindex + '].dateArr'] = [...dateArr];
        pageInstance.setData(newData);
        this.signInGetSignedDates(compindex, pageInstance, this.signInFn); // 查询所有已签到的日期
      }
    })
  }

  // 获取所有已签到的日期
  signInGetSignedDates = (compindex, pageInstance, fn) => {
    let activity_id = pageInstance.data.eles[compindex].activity_id;
    app.sendRequest({
      url: '/index.php?r=appSignActivity/GetSignedDates',
      data: {
        activity_id: activity_id,
        include_today: 1,
      },
      success: function (res) {
        typeof fn == 'function' && fn(compindex, pageInstance, res.data);
      }
    })
  }

  // 关闭领取成功窗口
  signInCloseSignModal = (compindex, pageInstance) => {
    clearTimeout(pageInstance.data.eles[compindex].timer);
    pageInstance.data.eles[compindex].timer = setTimeout(() => {
      this.signInGetIntegral(compindex, pageInstance);
    }, 3000)
  }

  // 关闭领取奖励弹窗
  signInGetIntegral = (compindex, pageInstance) => {
    let newData = {};
    newData['eles[' + compindex + '].showSignMask'] = false;
    newData['eles[' + compindex + '].showSignSus'] = false;
    pageInstance.setData(newData);
  }

  // 获取用户积分
  signInGetIntegralInfo = (compindex, pageInstance) => {
    let newData = {};
    app.sendRequest({
      url: '/index.php?r=AppShop/GetIntegralInfo',
      data: {},
      success: function (res) {
        newData['eles[' + compindex + '].can_use_integral'] = res.data.can_use_integral;
        pageInstance.setData(newData)
        console.log(pageInstance)
      }
    })
  }

  // 格式化时间轴数组
  signInFn = (compindex, pageInstance, opt) => {
    let dateArr = pageInstance.data.eles[compindex].dateArr;

    let cur_date = pageInstance.data.eles[compindex].cur_date;
    let hasSign = pageInstance.data.eles[compindex].hasSign;

    let newArray = opt.map((item) => {
      return utils.formatTimeYMD(item, 'MM.DD')
    })

    for (let i = 0; i < dateArr.length; i++) {
      for (let j = 0; j < newArray.length; j++) {
        if (dateArr[i].date === newArray[j]) {
          dateArr[i].isSign = true;
        }
      }
    }

    let showDateArr = dateArr;
    let newData = {};
    let width = 0;
    // 设置进度条长度
    for (let k = 0; k < showDateArr.length; k++) {
      if (showDateArr[k].date === cur_date) {
        // 展示数组的总宽度是 630 去掉前端和后端 应为540 
        if (!hasSign && k === 0) {
          width = 20;
        } else {
          width = k / (showDateArr.length - 1) * 540 + 60;
        }
        newData['eles[' + compindex + '].signInProgressWidth'] = width;
      }
    }
    newData['eles[' + compindex + '].dateArr'] = dateArr;
    newData['eles[' + compindex + '].showDateArr'] = showDateArr;
    newData['eles[' + compindex + '].signedDays'] = opt.length;
    pageInstance.setData(newData);
  }

  // 阻止滚动穿透
  signInNotMove = (e) => {}

  // 跳转路径页面
  signInNavigatorTo = (e) => {
    let type = e.currentTarget.dataset.type.toString();
    let url = '';
    switch (type) {
      case '1':
        url = '/userCenter/pages/myIntegral/myIntegral'
        break;
      case '2':
        url = '/eCommerce/pages/balance/balance'
        break;
      case '3':
        url = '/eCommerce/pages/couponList/couponList'
        break;
      case '4':
        let detail = e.target.dataset.detail;
        url = '/eCommerce/pages/vipCard/vipCard?is_paid_vip=1&detail=' + detail
        break;
      case '5':
        let start_time = e.target.dataset.start;
        let end_time = e.target.dataset.end;
        url = '/signIn/pages/calendar/calendar' + '?start_time=' + start_time + '&end_time=' + end_time;
        break;
      case '6':
        url = '/signIn/pages/retroactive/retroactive'
        break;
      case '7':
        url = '/signIn/pages/rule/rule'
        break;
    }
    app.turnToPage(url, false);
  }

  signInSubmit = (e) => {
    // TODO
    // let form_id = e.detail.formId || '';
    let form_id = '';
    let compindex = e.currentTarget.dataset.compindex;
    let pageInstance = app.getAppCurrentPage();

    this.signIn(compindex, pageInstance, form_id);
    this.signInSendForm(compindex, pageInstance, form_id);
  }

  // 推送模板消息
  signInSendForm = (compindex, pageInstance, form_id) => {
    let sendFormIdTimes = pageInstance.data.eles[compindex].sendFormIdTimes;
    let newData = {};
    if (sendFormIdTimes === 0) {
      app.sendRequest({
        url: '/index.php?r=api/AppMsgTpl/SaveUserFormId',
        data: {
          form_id: form_id
        },
        method: 'post',
        success: function (res) {
          newData['eles[' + compindex + '].sendFormIdTimes'] = 2;
          pageInstance.setData(newData);
        }
      })
    }
  }

  // switch开关
  signInChangeSwitch = (checked, compindex) => {
    let pageInstance = app.getAppCurrentPage();
    let activity_id = pageInstance.data.eles[compindex].activity_id;
    // TODO
    // let checked = e.target.value;
    let newData = {};
    newData['eles[' + compindex + '].continuous_notice_user'] = checked;
    pageInstance.setData(newData);
    app.sendRequest({
      url: '/index.php?r=appSignActivity/SignNoticeSwitch',
      data: {
        'activity_id': activity_id,
        'switch': checked ? 1 : 0
      },
      success: function (res) {
        if (res.status !== 0) {
          newData['eles[' + compindex + '].continuous_notice_user'] = !checked;
          pageInstance.setData(newData);
        }
      }
    })
  }

  // 领取额外奖励按钮formId
  signInReceiveExtReward = (e) => {
    // TODO
    // let form_id = e.detail.formId;
    let form_id = '';
    let type = e.currentTarget.dataset.type;
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.currentTarget.dataset.compindex;
    let method = e.currentTarget.dataset.method;
    this.signInGetReward(compindex, pageInstance, form_id, type, method);
  }

  // 关闭领取奖励弹窗
  signInSusClose = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.target.dataset.compindex;
    let newData = {};
    newData['eles[' + compindex + '].showSignMask'] = false;
    newData['eles[' + compindex + '].showSignSus'] = false;
    pageInstance.setData(newData);
  }

  // 领取额外奖励
  signInGetReward = (compindex, pageInstance, form_id, type, method) => {
    let newData = {};
    let activity_id = pageInstance.data.eles[compindex].activity_id;
    app.sendRequest({
      url: '/index.php?r=appSignActivity/ReceiveExtraReward',
      data: {
        activity_id: activity_id,
        reward_type: type,
        received_method: method,
        form_id: form_id,
      },
      success: (res) => {
        switch (type) {
          case 1:
            type = '积分'
            break;
          case 2:
            type = '储值'
            break;
          case 3:
            type = '优惠券'
            break;
          case 4:
            type = '会员卡'
            break;
        }
        newData['eles[' + compindex + '].showSignMask'] = true;
        newData['eles[' + compindex + '].showSignSus'] = true;
        newData['eles[' + compindex + '].successTips'] = type + '领取成功';
        pageInstance.setData(newData);
        this.signInExtraRewards(compindex, pageInstance); // 查看
        if (type == '积分') {
          this.signInGetIntegralInfo(compindex, pageInstance); // 刷新积分
        }
      },
      successStatusAbnormal: function () {
        app.showToast({
          title: '库存不足',
          icon: 'none',
          duration: 1500
        })
        return false;
      }
    })
    this.signInCloseSignModal(compindex, pageInstance);
  }

  getRgbColor = (sHex, alpha = 1) => {
    arr = [
      sHex.substring(1, 3),
      sHex.substring(3, 5),
      sHex.substring(5)
    ];
    brr = arr.map(function(item, index) {
      return parseInt(item, 16);
    });
    return 'rgba(' + brr.join(',') + ',' + alpha + ')';
  }

  render() {
    const data = this.state.eles[0]
    
    if(!data){
      return <div></div>
    }
    let {
      activityData, nodata,
      showSignMask, default_style, style_settings,
      advance, can_use_integral, continuous_sign,
      showDateArr, hasSign, giftTips_con,
      giftTips_acc, continuous_notice, continuous_notice_user,
      continuous_array, accumulate_array, showSignSus,
      successTips, signInProgressWidth, cur_date
    } = data;
    activityData = activityData || {};
    style_settings = style_settings || {};

    /**
     * @desc 活动未开始
     */
    const activityNoStart = () => {
      let content = null;
      if (!activityData.id && nodata) {
        content = <div className='signIn-notActive'>
          <div className='signIn-showImage'>
            <img src='https://cdn.jisuapp.cn/static/webapp/images/retroactive/notActive.png' />
            <div className='signIn-notActive-exp'>活动未开始，敬请期待</div>
          </div>
        </div>
      }
      return content;
    };

    /**
     * @desc 有活动的情况
     */
    const signWrap = () => (
      <div>
        {activityData.id && 
          <div className="qiandao-sign">
            <div className="signIn-sign-mask"
                 style={{ display: showSignMask ? 'block' : 'none' }}
                 onTouchMove={this.signInNotMove}></div>
            {(default_style == 1 || default_style == 2) &&
            <div className="signIn-sign-bg"
                 style={{ background: style_settings.background_image
                            ? "url("+style_settings.background_image+") no-repeat center /100% 100%;"
                            : style_settings.background_color
                       }}>
              {/* <div className="signIn-sign-rule"
                   data-type={7}
                   onClick={this.signInNavigatorTo}
                   style={{ color: advance.color_style
                                        ? advance.color_style.rule
                                        : "#FFFFFF",
                            background: advance.color_style
                                        ? advance.color_style.background
                                        : "linear-gradient(180deg, rgba(255, 195, 29, 1) 0%, rgba(255, 181, 64, 1) 100%)"
                         }}>
                规则
              </div> */}
              <div className="signIn-cur-integral"
                   style={{ color: advance.color_style ? advance.color_style.main : "" }}>
                当前积分
              </div>
              <div className="signIn-cur-integral-num"
                   style={{ color: advance.color_style ? advance.color_style.main : "" }}>
                {can_use_integral || 0}
              </div>
              <div className="signIn-integral-record"
                   style={{ color: advance.color_style ? advance.color_style.main : "" ,
                            border: `.01rem solid ${ advance.color_style ? advance.color_style.main : "#fff" }`
                         }}
                   data-type={1}
                   onClick={this.signInNavigatorTo}>
                积分记录
              </div>
            </div>
            }
            {default_style == 3 &&
              <div style={{ paddingBottom: "1.8rem" }}>
                <div className="sign-bg3"
                     style={{ background: style_settings.background_image
                                              ? `url("${ style_settings.background_image }") no-repeat center /100% 100%;`
                                              : style_settings.background_color
                           }}>
                  {/* <form bindsubmit='signInSendFormId'>
                    <div className="sign-calendar3"
                         style={{ backgroundColor: advance.color_style ? advance.color_style.sign_calendar : '' }}
                         data-compindex={this.props.index}
                         data-type={5}
                         data-start={this.props.start_time}
                         data-end={this.props.end_time}
                         onClick={this.signInNavigatorTo}>
                      签到日历
                    </div>
                  </form> */}
                  <div className="sign-accumulateDays" style={{ color: advance.color_style.sign_day }}>
                    累计签到
                    <span style={{ fontSize: ".48rem" }}>{signedDays}</span>
                    天
                  </div>
                  <div className="sign-signIn3">
                    <form style={{ margin: "0 auto" }}>
                      <button type="button"
                              className="signIn-signactive"
                              style={{ background: advance.color_style
                                                      ? advance.color_style.main
                                                      : "linear-gradient(144deg,rgba(251,240,216,1) 0%,rgba(244,225,185,1) 100%)",
                                       color: "#4D4338",
                                       display: hasSign ? 'none' : 'hidden'
                                    }}
                              data-compindex={0}
                              onClick={this.signInSubmit}>
                        签到
                      </button>
                      <div className='signIn-signed'
                          style={{ background: advance.color_style
                                                    ? advance.color_style.main
                                                    : "linear-gradient(144deg,rgba(251,240,216,1) 0%,rgba(244,225,185,1) 100%)",
                                   color: '#4D4338',
                                   display: hasSign ? 'flex': 'none'
                                }}>
                        已签到
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            }

            <div className="signIn-sign-box">
              <div className='signIn-sign-wrapper'>
                <div className='signIn-sign-info'>
                  <span className='signIn-sign-sum'>
                    已连续签到
                    <span style={{ color: advance.color_style ? advance.color_style.rule_span : "#F00",
                                   margin: '0 .05rem',
                                   fontWeight: 'bold'
                                }}>
                      {continuous_sign}
                    </span>
                    天
                  </span>
                  {/* <form>
                    <button type="button"
                            className='signIn-sign-calendar'
                            data-compindex={this.props.compindex}
                            data-type={5}
                            data-start={this.props.start_time}
                            data-end={this.props.end_time}
                            onClick={this.signInNavigatorTo}
                            style={{ background: 'none', border: 'none', padding: 0 }}>
                      <span className='signIn-sign-calendarIcon'></span>
                      签到日历
                    </button>
                  </form> */}
                </div>
                {showDateArr.length > 1 &&
                  <React.Fragment>
                    <div className='signIn-sign-progress-box'
                         style={{ background: advance.color_style
                                                  ? this.getRgbColor(advance.color_style.background,0.2)
                                                  : "#fff0b8"
                               }}>
                      <div className='signIn-sign-progress'
                          style={{ width: `${ +signInProgressWidth * 0.01 }rem`,
                                   backgroundColor: advance.color_style
                                                        ? advance.color_style.rule_span
                                                        : default_style === 1 ? "#FF7235" : "#930bd4"
                                }}>
                      </div>
                    </div>
                    <div className='signIn-sign-date'>
                      {showDateArr.map(item => (
                        <React.Fragment key={item.date}>
                          <div className='signIn-date-item'>
                            {item.date === cur_date ? '今天' : item.date}
                            <div className='signIn-date-dot'
                                style={{ backgroundColor: advance.color_style
                                                              ? advance.color_style.background
                                                              : default_style === 1 ? "#ffaf52":"#FFC568"
                                      }}>
                            </div>
                            <div className='signIn-date-integral'
                                style={{ background: advance.color_style
                                                          ? advance.color_style.background
                                                          : "linear-gradient(180deg, rgba(255, 223, 32, 1) 0%, rgba(255, 189, 31, 1) 100%)",
                                        color: advance.color_style ? advance.color_style.rule : "#674444",
                                        display: item.isSign ? 'none' : 'block'
                                      }}>
                              +{item.integral}
                              <div className='signIn-date-triangle'
                                  style={{ borderTopColor: advance.color_style ? advance.color_style.background : "#ffc61f",
                                          display: item.isSign ? 'none' : 'block'
                                        }}>
                              </div>
                            </div>
                            {item.isSign && 
                              <div className='signIn-date-signIn'
                                  style={{ background: `url(${ advance
                                                                    ? advance.signed_icons
                                                                    : default_style === 1
                                                                          ? "https://cdn.jisuapp.cn/static/webapp/images/retroactive/signIn.png) no-repeat center/contain"
                                                                          : "https://cdn.jisuapp.cn/static/webapp/images/retroactive/signIn2.png) no-repeat center/contain" }`
                                        }}>
                              </div>
                            }
                            {(item.accumulatedReward || item.continuousReward) &&
                              <div className='signIn-date-gift'
                                style={{ background: `url(${ advance
                                                              ? advance.gift_icons
                                                              : default_style === 1
                                                                    ? "https://cdn.jisuapp.cn/static/webapp/images/retroactive/gift.png) no-repeat center/contain"
                                                                    : "https://cdn.jisuapp.cn/static/webapp/images/retroactive/gift2.png) no-repeat center/contain" }`,
                                        display: item.date === cur_date && hasSign ? 'none' : 'block'
                                      }}>
                              </div>
                            }
                          </div>
                        </React.Fragment>
                      ))}
                    </div>
                  </React.Fragment>        
                }

                {/* 没有连续签到且只剩下一天活动 */}
                {showDateArr.length === 1 &&
                  <div className='signIn-last-date-box'>
                    <img className='signIn-lastIcon' src={`https://cdn.jisuapp.cn/static/webapp/images/retroactive/${ hasSign ? "signIn.png" : "lastCoin.png" }`} />
                    <span className='signIn-lastTxt' style={{ color: hasSign ? "#999" : "#674444" }}>
                      { hasSign ? "成功完成签到，你真棒" : `+${ showDateArr[showDateArr.length-1].integral }` }
                    </span>
                    <span className='signIn-lastTxt'></span>
                  </div>        
                }
                <div className='signIn-sign-button'>
                  <form style={{ margin: '0 auto' }}>
                    <button type="button"
                            className='signIn-signactive'
                            style={{ background: advance.color_style
                                                    ? advance.color_style.rule_span
                                                    : default_style === 1
                                                          ? "linear-gradient(90deg, rgba(255, 135, 0, 1) 0%, rgba(255, 67, 62, 1) 100%)"
                                                          : "linear-gradient(90deg, rgba(197, 48, 249, 1) 0%, rgba(116, 59, 255, 1) 100%)",
                                     display: hasSign ? 'none': 'block'
                                  }}
                            data-compindex={0}
                            onClick={this.signInSubmit}>
                      签到
                    </button>
                    <div className='signIn-signed'
                        style={{ background: advance.color_style
                                                  ? advance.color_style.rule_span
                                                  : default_style === 1
                                                        ? "#ff6c19"
                                                        : "linear-gradient(90deg, rgba(197, 48, 249, 1) 0%, rgba(116, 59, 255, 1) 100%)",
                                 display: hasSign ? 'flex': 'none'
                              }}>
                      已签到
                    </div>
                  </form>
                </div>
                <div className='signIn-gift-tips'>
                  {giftTips_con}{giftTips_con && giftTips_acc ? "，" : ""}{giftTips_acc}
                </div>
              </div>
              {continuous_notice == 1 &&
                <div className='signIn-sign-remind'>
                  <List>
                    <List.Item
                      extra={<Switch className="switch"
                                      color={advance.color_style ? advance.color_style.rule_text : default_style === 1 ? '#fe4739' : '#801dfe'}
                                      checked={continuous_notice_user}
                                      onChange={(e) => this.signInChangeSwitch(e, this.props.index)} />}>
                      <div className="signIn-remind-box">
                        <div className='signIn-icon-shalou'></div>
                        <div className='signIn-remind-info'>
                          <div className='signIn-remind-info-t'>连续签到提醒</div>
                          <div className='signIn-remind-info-b'>开启开关，每天12:00将会以模板消息方式提醒</div>
                        </div>
                      </div>
                    </List.Item>
                  </List>
                </div>
              }
              {continuous_array && continuous_array.rewards && continuous_array.rewards.length > 0 && 
                <div className='signIn-reward-box'>
                  <div className='signIn-reward-title'>连续签到额外奖励</div>
                  <div className='signIn-reward-chooseNum'
                      style={{ color: advance.color_style
                                          ? advance.color_style.rule_text
                                          : default_style === 1
                                                ? "#FE4739"
                                                : "#6240FE",
                               display: continuous_array.kind_limit == 99999 ? 'none': 'block'
                            }}>
                    以下奖励选{ continuous_array.kind_limit || 1 }个
                  </div>
                  <div className='signIn-reward-type'>
                    {continuous_array.rewards.map((item, index) => (
                      <React.Fragment key={index}>
                        {(item.received || continuous_array.received_times != continuous_array.kind_limit) &&
                        <div className='signIn-reward-item'>
                          <div>
                            {item.type === 1 && <div className='signIn-award-top'>积分</div>}
                            {item.type === 2 && <div className='signIn-award-top'>储值</div>}
                            {item.type === 3 && <div className='signIn-award-top'>优惠券</div>}
                            {item.type === 4 && <div className='signIn-award-top'>会员卡</div>}
                            {continuous_array.kind_limit != continuous_array.received_times &&
                              <React.Fragment>
                                {continuous_array.rewards.length === 4 && 
                                  <div className='signIn-award-bottom' style={{ maxWidth: '1.3rem' }}>
                                    {item.title ? item.title : item.value}
                                  </div>
                                }
                                {continuous_array.rewards.length === 3 &&
                                  <div className='signIn-award-bottom' style={{ maxWidth: '1.56rem'}}>
                                    {item.title ? item.title : item.value}
                                  </div>
                                }
                                {continuous_array.rewards.length !== 4 && continuous_array.rewards.length !== 3 &&
                                  <div className='signIn-award-bottom' style={{ maxWidth: '2.6rem'}}>
                                    {item.title ? item.title : item.value}
                                </div>
                                }
                              </React.Fragment>
                            }
                            {continuous_array.kind_limit == continuous_array.received_times &&
                              <React.Fragment>
                                {continuous_array.kind_limit == 4 &&
                                  <div className='signIn-award-bottom' style={{ maxWidth: '1.3rem'}}>
                                    {item.title ? item.title : item.value}
                                  </div>
                                }
                                {continuous_array.kind_limit == 3 &&
                                  <div className='signIn-award-bottom' style={{ maxWidth: '1.56rem'}}>
                                    {item.title ? item.title : item.value}
                                  </div>
                                }
                                {continuous_array.kind_limit != 4 && continuous_array.kind_limit != 3 &&
                                  <div className='signIn-award-bottom' style={{ maxWidth: '2.6rem' }}>
                                    {item.title ? item.title : item.value}
                                  </div>
                                }
                              </React.Fragment>
                            }
                          </div>
                          <form>
                            {!item.received && (continuous_array.received_times < continuous_array.kind_limit) &&
                              <button type="button"
                                      className='signIn-getRewardBtn signIn-get-reward'
                                      style={{ background: advance.color_style
                                                              ? advance.color_style.rule_text
                                                              : default_style === 1
                                                                    ? "linear-gradient(90deg, rgba(255, 135, 0, 1) 0%, rgba(255, 67, 62, 1) 100%)"
                                                                    : "linear-gradient(90deg, rgba(197, 48, 249, 1) 0%, rgba(116, 59, 255, 1) 100%)",
                                               padding: 0
                                            }}
                                      data-type={item.type}
                                      data-method={2}
                                      data-compindex={this.props.index}
                                      onClick={this.signInReceiveExtReward}>
                                领取
                              </button>
                            }
                            {item.received &&
                              <div className='signIn-getRewardBtn signIn-see_get-reward'
                                   style={{ background: advance.color_style
                                                          ? this.getRgbColor(advance.color_style.rule_text,0.1)
                                                          : default_style === 1
                                                                ? "rgba(255, 240, 219, 1)"
                                                                : "rgba(128, 29, 254, 0.1)",
                                           color: advance.color_style ? advance.color_style.rule_text : default_style === 1 ? "#ff7e0f" : "#6240FE"
                                        }}
                                   data-detail={item.value}
                                   data-type={item.type}
                                   onClick={this.signInNavigatorTo}>
                                查看
                              </div>
                            }
                            {!item.received && (continuous_array.received_times == continuous_array.kind_limit) &&
                              <div className='signIn-getRewardBtn signIn-cant_get-reward'>
                                不可领取
                              </div>
                            }
                          </form>
                        </div>
                        }

                      </React.Fragment>
                    ))}
                  </div>
                </div> 
              }
              {accumulate_array && accumulate_array.rewards && accumulate_array.rewards.length > 0 &&
                <div className='signIn-reward-box'>
                  {accumulate_array.accumulate_type == 2 &&
                    <div className='signIn-reward-title'>
                      当月累计签到满{accumulate_array.hit_day}天额外奖励
                    </div> 
                  }
                  {accumulate_array.accumulate_type == 1 &&
                    <div className='signIn-reward-title'>
                      累计签到额外奖励
                    </div>
                  }
                  <div className='signIn-reward-chooseNum'
                      style={{ color: advance.color_style ? advance.color_style.rule_text : default_style === 1 ? "#FE4739" : "#6240FE",
                               display: accumulate_array.kind_limit == 9999 ? 'none' : 'block'
                            }}>
                    以下奖励选{accumulate_array.kind_limit || 1}个
                  </div>
                  <div className='signIn-reward-type'>
                    {accumulate_array.rewards.map((item, index) => (
                      <React.Fragment key={index}>
                        {(item.received || accumulate_array.received_times != accumulate_array.kind_limit) &&
                          <div className='signIn-reward-item'>
                            <div>
                              {item.type === 1 && <div className='signIn-award-top'>积分</div>}
                              {item.type === 2 && <div className='signIn-award-top'>储值</div>}
                              {item.type === 3 && <div className='signIn-award-top'>优惠券</div>}
                              {item.type === 4 && <div className='signIn-award-top'>会员卡</div>}
                              {accumulate_array.kind_limit != accumulate_array.received_times &&
                                <React.Fragment>
                                  {accumulate_array.rewards.length === 4 &&
                                    <div className='signIn-award-bottom' style={{ maxWidth: '1.3rem' }}>
                                      {item.title ? item.title : item.value}
                                    </div>
                                  }
                                  {accumulate_array.rewards.length === 3 &&
                                    <div className='signIn-award-bottom' style={{ maxWidth: '1.56rem' }}>
                                      {item.title ? item.title : item.value}
                                    </div>
                                  }
                                  {accumulate_array.rewards.length !== 4 && accumulate_array.rewards.length !== 3 &&
                                    <div className='signIn-award-bottom' style={{ maxWidth: '2.6rem' }}>
                                      {item.title ? item.title : item.value}
                                    </div>
                                  }
                                </React.Fragment>
                              }
                              {accumulate_array.kind_limit == accumulate_array.received_times &&
                                <React.Fragment>
                                  {accumulate_array.kind_limit == 4 &&
                                    <div className='signIn-award-bottom' style={{ maxWidth: '1.3rem' }}>
                                      {item.title ? item.title : item.value}
                                    </div>
                                  }
                                  {accumulate_array.kind_limit == 3 &&
                                    <div className='signIn-award-bottom' style={{ maxWidth: '1.56rem'}}>
                                      {item.title ? item.title : item.value}
                                    </div>
                                  }
                                  {accumulate_array.kind_limit != 4 && accumulate_array.kind_limit != 3 &&
                                    <div className='signIn-award-bottom' style={{ maxWidth: '2.6rem'}}>
                                      {item.title ? item.title : item.value}
                                    </div>
                                  }
                                </React.Fragment>
                              }
                            </div>
                            <form>
                              {!item.received && (accumulate_array.received_times < accumulate_array.kind_limit) &&
                                <button type="button"
                                        className='signIn-getRewardBtn signIn-get-reward'
                                        style={{ background: advance.color_style
                                                                ? advance.color_style.rule_text
                                                                : default_style === 1
                                                                      ? "linear-gradient(90deg, rgba(255, 135, 0, 1) 0%, rgba(255, 67, 62, 1) 100%)"
                                                                      : "linear-gradient(90deg, rgba(197, 48, 249, 1) 0%, rgba(116, 59, 255, 1) 100%)",
                                                 padding: 0
                                              }}
                                        data-type={item.type}
                                        data-method={2}
                                        data-compindex={this.props.index}
                                        onClick={this.signInReceiveExtReward}>
                                  领取
                                </button>
                              }
                              {item.received &&
                                <div className='signIn-getRewardBtn signIn-see_get-reward'
                                     style={{ background: advance.color_style
                                                              ? this.getRgbColor(advance.color_style.rule_text,0.1)
                                                              : default_style === 1
                                                                    ? "rgba(255, 240, 219, 1)"
                                                                    : "rgba(128, 29, 254, 0.1)",
                                             color: advance.color_style ? advance.color_style.rule_text : default_style === 1 ? "#ff7e0f":"#6240FE"
                                           }}
                                     data-detail={item.value}
                                     data-type={item.type}
                                     onClick={this.signInNavigatorTo}>
                                  查看
                                </div>
                              }
                              {!item.received && (accumulate_array.received_times >= accumulate_array.kind_limit) &&
                                <div className='signIn-getRewardBtn signIn-cant_get-reward'>
                                  不可领取
                                </div>
                              }
                            </form>
                          </div>                        
                        }

                      </React.Fragment>
                    ))
                    }
                  </div>
                </div>
              }
            </div>
            {default_style == 3 &&
              <div className='signIn-sign-box'
                  style={{ paddingBottom: (continuous_array.rewards.length || accumulate_array.rewards.length) ? "1.5rem" : "" }}>
                {continuous_array.rewards.length &&
                  <div className='signIn-reward-box'>
                    <div className='signIn-reward-title'>连续签到额外奖励</div>
                    <div className='signIn-reward-chooseNum'
                        style={{ color: advance.color_style ? advance.color_style.main : "",
                                 display: continuous_array.kind_limit == 99999 ? 'none' : 'block'
                              }}>
                      以下奖励选{continuous_array.kind_limit || 1}个
                    </div>
                    <div className='signIn-reward-type'>
                      {continuous_array.rewards.map(item => (
                        <React.Fragment key={item.id}>
                          {(item.received || continuous_array.received_times != continuous_array.kind_limit) &&
                            <div className='signIn-reward-item'>
                              <div>
                                {item.type === 1 && <div className='signIn-award-top'>积分</div>}
                                {item.type === 2 && <div className='signIn-award-top'>储值</div>}
                                {item.type === 3 && <div className='signIn-award-top'>优惠券</div>}
                                {item.type === 4 && <div className='signIn-award-top'>会员卡</div>}
                                {continuous_array.kind_limit != continuous_array.received_times &&
                                  <React.Fragment>
                                    {continuous_array.rewards.length === 4 && 
                                      <div className='signIn-award-bottom' style={{ maxWidth: '1.3rem' }}>
                                        {item.title ? item.title : item.value}
                                      </div>
                                    }
                                    {continuous_array.rewards.length === 3 &&
                                      <div className='signIn-award-bottom' style={{ maxWidth: '1.56rem'}}>
                                        {item.title ? item.title : item.value}
                                      </div>
                                    }
                                    {continuous_array.rewards.length !== 4 && continuous_array.rewards.length !== 3 &&
                                      <div className='signIn-award-bottom' style={{ maxWidth: '2.6rem'}}>
                                        {item.title ? item.title : item.value}
                                    </div>
                                    }
                                  </React.Fragment>
                                }
                                {continuous_array.kind_limit == this.continuous_array.received_times &&
                                  <React.Fragment>
                                    {continuous_array.kind_limit == 4 &&
                                      <div className='signIn-award-bottom' style={{ maxWidth: '1.3rem'}}>
                                        {item.title ? item.title : item.value}
                                      </div>
                                    }
                                    {continuous_array.kind_limit == 3 &&
                                      <div className='signIn-award-bottom' style={{ maxWidth: '1.56rem'}}>
                                        {item.title ? item.title : item.value}
                                      </div>
                                    }
                                    {continuous_array.kind_limit != 4 && continuous_array.kind_limit != 3 &&
                                      <div className='signIn-award-bottom' style={{ maxWidth: '2.6rem' }}>
                                        {item.title ? item.title : item.value}
                                      </div>
                                    }
                                  </React.Fragment>
                                }
                              </div>
                              <form>
                                {!item.received && (continuous_array.received_times < continuous_array.kind_limit) &&
                                  <button type="button"
                                          className='signIn-getRewardBtn signIn-get-reward'
                                          style={{ background: advance.color_style ? advance.color_style.main : "", padding: 0 }}
                                          data-type={item.type}
                                          data-method={2}
                                          data-compindex={this.props.index}
                                          onClick={this.signInReceiveExtReward}>
                                    领取
                                  </button>
                                }
                                {item.received &&
                                  <div className='signIn-getRewardBtn signIn-see_get-reward'
                                      style={{ background: advance.color_style ? this.getRgbColor(advance.color_style.main,0.1) : "",
                                               color: advance.color_style ? advance.color_style.main : ""
                                            }}
                                      data-detail={item.value}
                                      data-type={item.type}
                                      onClick={(e) => this.signInNavigatorTo(e)}>
                                    查看
                                  </div>
                                }
                                {!item.received && (continuous_array.received_times == continuous_array.kind_limit) &&
                                  <div className='signIn-getRewardBtn signIn-cant_get-reward'>
                                    不可领取
                                  </div>
                                }
                              </form>
                            </div>
                          }
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                }
                {accumulate_array.rewards.length &&
                  <div className='signIn-reward-box'>
                    {accumulate_array.accumulate_type == 2 &&
                      <div className='signIn-reward-title'>
                        当月累计签到满{accumulate_array.hit_day}天额外奖励
                      </div> 
                    }
                    {accumulate_array.accumulate_type == 1 &&
                      <div className='signIn-reward-title'>
                        累计签到额外奖励
                      </div>
                    }
                    <div className='signIn-reward-chooseNum'
                        style={{ color: advance.color_style ? advance.color_style.main : '',
                                 display: accumulate_array.kind_limit == 9999 ? 'none' : 'block'
                              }}>
                      以下奖励选{accumulate_array.kind_limit || 1}个
                    </div>
                    <div className='signIn-reward-type'>
                      {accumulate_array.rewards.map(item => (
                        <React.Fragment key={item.id}>
                          {(item.received || accumulate_array.received_times != accumulate_array.kind_limit) &&
                            <div className='signIn-reward-item'>
                              <div>
                                {item.type === 1 && <div className='signIn-award-top'>积分</div>}
                                {item.type === 2 && <div className='signIn-award-top'>储值</div>}
                                {item.type === 3 && <div className='signIn-award-top'>优惠券</div>}
                                {item.type === 4 && <div className='signIn-award-top'>会员卡</div>}
                                {accumulate_array.kind_limit != accumulate_array.received_times &&
                                  <React.Fragment>
                                    {accumulate_array.rewards.length === 4 &&
                                      <div className='signIn-award-bottom' style={{ maxWidth: '1.3rem' }}>
                                        {item.title ? item.title : item.value}
                                      </div>
                                    }
                                    {accumulate_array.rewards.length === 3 &&
                                      <div className='signIn-award-bottom' style={{ maxWidth: '1.56rem' }}>
                                        {item.title ? item.title : item.value}
                                      </div>
                                    }
                                    {accumulate_array.rewards.length !== 4 && accumulate_array.rewards.length !== 3 &&
                                      <div className='signIn-award-bottom' style={{ maxWidth: '2.6rem' }}>
                                        {item.title ? item.title : item.value}
                                      </div>
                                    }
                                  </React.Fragment>
                                }
                                {accumulate_array.kind_limit == accumulate_array.received_times &&
                                  <React.Fragment>
                                    {accumulate_array.kind_limit == 4 &&
                                      <div className='signIn-award-bottom' style={{ maxWidth: '1.3rem' }}>
                                        {item.title ? item.title : item.value}
                                      </div>
                                    }
                                    {accumulate_array.kind_limit == 3 &&
                                      <div className='signIn-award-bottom' style={{ maxWidth: '1.56rem'}}>
                                        {item.title ? item.title : item.value}
                                      </div>
                                    }
                                    {accumulate_array.kind_limit != 4 && accumulate_array.kind_limit != 3 &&
                                      <div className='signIn-award-bottom' style={{ maxWidth: '2.6rem'}}>
                                        {item.title ? item.title : item.value}
                                      </div>
                                    }
                                  </React.Fragment>
                                }
                              </div>
                              <form>
                                {!item.received && (accumulate_array.received_times < accumulate_array.kind_limit) &&
                                  <button type="button"
                                          className='signIn-getRewardBtn signIn-get-reward'
                                          style={{ background: advance.color_style ? advance.color_style.main : '', padding: 0 }}
                                          data-type={item.type}
                                          data-method={3}
                                          data-compindex={this.props.index}
                                          onClick={this.signInReceiveExtReward}>
                                    领取
                                  </button>
                                }
                                {item.received &&
                                  <div className='signIn-getRewardBtn signIn-see_get-reward'
                                       style={{ background: advance.color_style ? this.getRgbColor(advance.color_style.main,0.1) : '',
                                               color: advance.color_style ? advance.color_style.main : ''
                                            }}
                                       data-detail={item.value}
                                       data-type={item.type}
                                       onClick={this.signInNavigatorTo}>
                                    查看
                                  </div>
                                }
                                {!item.received && (accumulate_array.received_times >= accumulate_array.kind_limit) &&
                                  <div className='signIn-getRewardBtn signIn-cant_get-reward'>
                                    不可领取
                                  </div>
                                }
                              </form>
                            </div>                        
                          }
                        </React.Fragment>
                      ))
                      }
                    </div>
                  </div>
                }
              </div>
            }
            {successWrap()}
          </div>
        }
      </div>
    );

    const successWrap = () => (
      <div className='signIn-sign-success'
           onTouchMove={this.signInNotMove}
           style={{ display: showSignSus ? 'block' : 'none' }}>
        <div className='signIn-sign-success-bg'></div>
        <div className='signIn-sign-success-box'>
          <div className='signIn-sign-success-tip'>{successTips}</div>
          <div className='signIn-sign-success-btn signIn-index'
               data-compindex={this.props.index}
               onClick={this.signInSusClose}>确定</div>
        </div>
      </div>
    );



    return (
      <div className="custom-component sign-in">
        {activityNoStart()}
        {signWrap()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/chatgpt-page/sign-in/SignIn.jsx